import React from 'react';
import { Text } from '@common/components';
import { InvoiceStateType } from '@pay-bill/graphql';
import { ColorsType } from '@common/tokens';

export const INVOICE_COLOR_STYLE_MAP: Record<InvoiceStateType, ColorsType> = {
  void: 'midnightDarkest',
  draft: 'sunDarker',
  open: 'skyRegular',
  paid: 'meadow',
  rejected: 'coral',
  resolved: 'meadowDarker',
  paid_off_platform: 'sunDarker',
};

export const INVOICE_LABEL_OVERWRITE: Record<InvoiceStateType, string> = {
  void: 'Voided',
  draft: 'Draft',
  open: 'Open',
  paid: 'Paid',
  rejected: 'Rejected',
  resolved: 'Resolved',
  paid_off_platform: 'Paid Off Platform',
};

export const InvoiceState = ({ state }: { state: InvoiceStateType }) => (
  <Text weight="bolder" color={INVOICE_COLOR_STYLE_MAP[state]}>
    {INVOICE_LABEL_OVERWRITE[state] || state}
  </Text>
);
